import { faCheck, faPenToSquare, faPlus, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, FormControl, Input, InputAdornment, InputLabel, MenuItem, Select, Skeleton, TextField, ThemeProvider } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react'
import { DateRangePicker } from 'react-dates';
import Button from '@mui/material/Button';
import moment from 'moment';
import { useApi } from '../Store/ApiContext';
import joi from 'joi';
import $ from 'jquery';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { addSuccessMessage, constantsErrorMessage, editSuccessMessage, successMessage, validationErrorMessage } from '../../constants/global';
import axios from 'axios';
import ToggleButton from '../ToggleButton/ToggleButton';
import { MuiTelInput } from 'mui-tel-input';
import { useTranslation } from 'react-i18next';
import RequestPaymentsFields from '../RequestPaymentsFields/RequestPaymentsFields';
import { PrintReceiptModal } from '../receipts/PrintReceiptModal';
import { Upload } from 'lucide-react';
import { getDownloadURL, getStorage, ref, uploadBytes } from '@firebase/storage';
import { customAlphabet } from 'nanoid';
import Spinner from '../Spinner/Spinner';
import UploadRequestImages from '../UploadRequestImages/UploadRequestImages';

export default function AddRequestPage({ theme, token, baseUrl, setRowData }) {

  const { showInvalidFeedback, getData, responseApi, getSlug } = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  // read query params from URL (unitId, reqFrom, reqTo)
  const [searchParams, setSearchParams] = useSearchParams();
  const queryUnitId = searchParams.get('unitId') || null;
  const queryReqFromRaw = searchParams.get('reqFrom') || null;
  const queryReqToRaw = searchParams.get('reqTo') || null;

  const queryReqFrom = queryReqFromRaw && moment(queryReqFromRaw).isValid()
    ? moment(queryReqFromRaw).utc().format()
    : null;
  const queryReqTo = queryReqToRaw && moment(queryReqToRaw).isValid()
    ? moment(queryReqToRaw).utc().format()
    : null;

  const [requestDataRow, setRequestDataRow,] = useState(location.state);
  const [unitResponse, setUnitResponse] = useState([]);
  const [units, setUnits] = useState('');
  const [unitValue, setUnitValue] = useState(units[0]?.label || null);
  const [unitInputValue, setUnitInputValue] = useState('');
  const [focusedInput, setFocusedInput] = useState(null);
  const [requestsAccepted, setRequestsAccepted] = useState([]);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [availableTimeUnit, setAvailableTimeUnit] = useState([]);
  const [transaction, setTransaction] = useState([])
  const [unitId, setUnitId] = useState('');
  const [newPrice, setNewPrice] = useState(0);
  const [availableTime, setAvailableTime] = useState(null);
  const [clientOrRentingUserValue, setClientOrRentingUserValue] = useState()
  const [clientResponse, setClientResponse] = useState([])
  const [rentingUserResponse, setRentingUserResponse] = useState([])
  const [client, setClient] = useState('');
  const [clientAndRentingUserValue, setClientAndRentingUserValue] = useState(null);
  const [clientAndRentingUserInputValue, setClientAndRentingUserInputValue] = useState('');
  const [unitCost, setUnitCost] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [infoUnit, setInfoUnit] = useState({});
  const [editTotalCost, setEditTotalCost] = useState(true)
  const [newClient, setNewClient] = useState(false);
  const [clearPaymentRows, setClearPaymentRows] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printType, setPrintType] = useState('deposit');
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [selectedRefund, setSelectedRefund] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadingUploadImage, setLoadingUploadImage] = useState(false);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBlockedDays, setIsLoadingBlockedDays] = useState(false);
  const [isLoadingRenderContentDay, setIsLoadingRenderContentDay] = useState(true);
  const [bookingPolicies, setBookingPolicies] = useState({});
  const [checkoutPolicy, setCheckoutPolicy] = useState({});
  const [requestData, setRequestData] = useState({
    reqClientName: "",
    client: clientAndRentingUserValue,
    clientPhone: "",
    clientIdNumber: "",
    reqFrom: null,
    reqTo: null,
    reqGuests: "",
    reqStatus: "",
    reqNights: 0,
    reqPayments: null,
    discountPercentage: 0,
    discountAmount: 0,
    deposit: 0,
    insurance: 0,
    reqTotalCost: 0,
    notes: "",
    idsImg: null,
    unit: unitValue,
  });
  // add new client in edit request
  const [newClientData, setNewClientData] = useState({
    reqClientName: "",
    clientPhone: "",
    clientIdNumber: "",
  });
  const [blockedDaysSet, setBlockedDaysSet] = useState(new Set());
  const [partialDaysSet, setPartialDaysSet] = useState(new Set());
  const [partialDaysInfo, setPartialDaysInfo] = useState(new Map());
  const [pendingDaysSet, setPendingDaysSet] = useState(new Set());

  useEffect(() => {
    document.title = t("Add request");
  }, []);

  // Load booking policies from backend
  const loadBookingPolicies = async () => {
    try {
      // booking policies
      const bookingPoliciesCached = sessionStorage.getItem("bookingPolicies");
      if (bookingPoliciesCached) {
        setBookingPolicies(JSON.parse(bookingPoliciesCached));
      } else {
        const response = await getData(null, 'bookingPolicies');
        // response shape may vary; handle results.bookingPolicies or results
        const bp = response?.results?.bookingPolicies || response?.results || null;
        if (bp) {
          setBookingPolicies(bp);
          sessionStorage.setItem("bookingPolicies", JSON.stringify(bp));
        }
      }
    } catch (error) {
      console.error('Error loading booking policies:', error);
      enqueueSnackbar(t('loadingFailed') || 'Failed to load policies', { variant: 'error' });
    }
  };

  // Load checkout policies from backend
  const loadCheckoutPolicies = async () => {
    try {
      // checkout policy
      const checkoutCached = sessionStorage.getItem("checkoutPolicy");
      if (checkoutCached) {
        setCheckoutPolicy(JSON.parse(checkoutCached));
      } else {
        const response = await getData(null, 'checkout/policy');
        const cp = response?.policy;
        if (cp) {
          setCheckoutPolicy(cp);
          sessionStorage.setItem("checkoutPolicy", JSON.stringify(cp));
        }
      }
    } catch (error) {
      console.error('Error loading booking policies:', error);
      enqueueSnackbar(t('loadingFailed') || 'Failed to load policies', { variant: 'error' });
    }
  };

  async function getRequestsAccepted(unitId) {
    const token = localStorage.getItem("token");
    const { data } = await axios({
      method: "get",
      url: `${baseUrl}request/acceptedRequestsUnit?q=${unitId}&request=${requestDataRow ? requestDataRow._id : ''}`,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${token}`,
      },
    })
    if (data.message === "success") {
      setRequestsAccepted(data.results.requests);
      setAvailableTimes(data.results.availableTimes);
    }
  }

  async function getUnitsAvailableWithDate(from, to) {
    const token = localStorage.getItem("token");
    const { data } = await axios({
      method: "get",
      url: `${baseUrl}request/unitsAvailableWithDate?from=${from}&to=${to}`,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${token}`,
      },
    })
    if (data.message === "success") {
      setUnitResponse(data.results);
      handleChange({}, "unit", null);
    }
  }

  async function getAvailableTimeUnit() {
    const token = localStorage.getItem("token")
    const { data } = await axios({
      method: "get",
      url: `${baseUrl}availableTime/availableTimeUnit/${unitId ? unitId : requestDataRow?.unit?._id}?startDate=${requestDataRow ? requestDataRow.reqFrom : requestData.reqFrom}&endDate=${requestDataRow ? requestDataRow.reqTo : requestData.reqTo}`,
      headers: {
        'Content-Type': 'application/json',
        "authorization": `Bearer ${token}`,
      },
    })
    if (data?.message === "success") {
      calcPriceNightsPerAvailableTime(data?.results, { startDate: requestDataRow ? requestDataRow.reqFrom : requestData.reqFrom, endDate: requestDataRow ? requestDataRow.reqTo : requestData.reqTo })
    }
  }

  // Helper: DST-safe day diff using UTC midnight to avoid 23h/25h days
  function diffDaysUTC(a, b) {
    return Math.round(moment.utc(b).startOf('day').diff(moment.utc(a).startOf('day'), "hours") / 24);
  }

  function calcPriceNightsPerAvailableTime(availableTimes, date) {
    let transaction = [];
    // Use UTC startOf('day') to avoid DST shifting hour counts
    const inputStartDate = moment.utc(date.startDate).startOf('day');
    const inputEndDate = moment.utc(date.endDate).startOf('day');

    availableTimes?.forEach((availableTime) => {
      if (availableTime.available === false) {
        setAvailableTime(false);
        return; // skip this period (continues forEach)
      }

      if (!availableTime.available) return;

      const atStart = moment.utc(availableTime.startDate).startOf('day');
      const atEnd = moment.utc(availableTime.endDate).startOf('day');

      // Clamp the available period to the booking range (intersection)
      const overlapStart = inputStartDate.isAfter(atStart) ? inputStartDate : atStart;
      const overlapEnd = inputEndDate.isBefore(atEnd) ? inputEndDate : atEnd;

      const nights = diffDaysUTC(overlapStart, overlapEnd);
      if (nights > 0) {
        setAvailableTime(true);
        transaction.push({ nights, price: availableTime.price });
      }
    });

    const allNights = diffDaysUTC(inputStartDate, inputEndDate);
    console.log(`Total nights (days only): ${allNights}`);

    const coveredNights = transaction.reduce((sum, t) => sum + t.nights, 0);
    const diffDays = allNights - coveredNights;

    if (diffDays > 0) {
      console.log(infoUnit.cost);
      transaction.push({ nights: diffDays, price: requestDataRow?.unit?.cost ? requestDataRow?.unit.cost : infoUnit.cost });
    }
    setTransaction(transaction);
    calculateRequestNights(transaction, allNights);
  }

  function calculateRequestNights(priceList, nights) {
    const { cost, costInterval } = requestDataRow?.unit ? infoUnit?.costInterval ? infoUnit : requestDataRow?.unit : infoUnit
    let totalCost = 0
    if (costInterval === "night") {
      priceList.forEach(ele => {
        totalCost += ele.nights * ele.price
      });
    } else if (costInterval === "month") {
      priceList.forEach(ele => {
        let months = ele.nights / 30.5
        totalCost += months * ele.price
      });
    } else if (costInterval === "3_months") {
      priceList.forEach(ele => {
        let months = ele.nights / (30.5 * 3)
        totalCost += months * ele.price
      });
    } else if (costInterval === "9_months") {
      priceList.forEach(ele => {
        let months = ele.nights / (30.5 * 9)
        totalCost += months * ele.price
      });
    } else if (costInterval === "12_months") {
      priceList.forEach(ele => {
        let months = ele.nights / (30.5 * 12)
        totalCost += months * ele.price
      });
    }
    console.log(totalCost);
    setTotalCost(totalCost?.toFixed(2));
    // console.log(totalCost - requestDataRow?.discountAmount != parseFloat(requestDataRow.reqTotalCost));
    // console.log(totalCost - requestDataRow?.discountAmount, parseFloat(requestDataRow.reqTotalCost));

    let myData = {};
    requestDataRow ? myData = { ...requestDataRow } : myData = { ...requestData };
    // ** change total and discount percentage after discount
    myData.reqNights = nights;
    const discountPercentage = myData.discountPercentage;
    const discountAmount = Math.round(totalCost * (discountPercentage / 100), 2);
    const reqTotalCostAfterDiscount = totalCost - discountAmount;
    myData["discountPercentage"] = discountPercentage;
    myData["discountAmount"] = discountAmount;
    myData["reqTotalCost"] = reqTotalCostAfterDiscount.toFixed(2);
    requestDataRow ? setRequestDataRow(myData) : setRequestData(myData);
  }

  // Helper to calculate blocked days and partial days
  function calculateBlockedAndPartialDays(requests) {
    const blocked = new Set();
    const partial = new Set();
    const partialInfo = new Map();
    const pending = new Set();

    // Track check-in and checkout days (with times) to detect same-day conflicts
    const checkInDays = new Map(); // key: date string, value: array of check-in times
    const checkOutDays = new Map(); // key: date string, value: array of checkout times

    // First pass: collect all check-in and checkout days (including pending requests)
    requests.forEach(({ reqFrom, reqTo, reqStatus }) => {
      if (!reqFrom || !reqTo) return;

      const fromMoment = moment.utc(reqFrom);
      const toMoment = moment.utc(reqTo);
      const fromDay = fromMoment.format("YYYY-MM-DD");
      const toDay = toMoment.format("YYYY-MM-DD");

      // Track check-in days
      if (!checkInDays.has(fromDay)) {
        checkInDays.set(fromDay, []);
      }
      checkInDays.get(fromDay).push(fromMoment);

      // Track checkout days
      if (!checkOutDays.has(toDay)) {
        checkOutDays.set(toDay, []);
      }
      checkOutDays.get(toDay).push(toMoment);
    });

    // Second pass: block appropriate days
    requests.forEach(({ reqFrom, reqTo, reqStatus }) => {
      if (!reqFrom || !reqTo) return;

      // Parse dates and ensure we're working with UTC start of day
      const fromMoment = moment.utc(reqFrom).startOf("day");
      const toMoment = moment.utc(reqTo).startOf("day");

      // For ALL requests: Skip first day (check-in), block middle days, skip last day (checkout)
      // UNLESS there's a conflict on the same day (both checkout and check-in on same day)
      let current = fromMoment.clone().add(1, "day");

      // Loop through days from day after reqFrom up to (but not including) reqTo
      while (current.isBefore(toMoment)) {
        if (reqStatus === "pending") {
          pending.add(current.format("YYYY-MM-DD"));
        } else {
          blocked.add(current.format("YYYY-MM-DD"));
        }
        current.add(1, "day");
      }

      // Special handling: If checkout day has a check-in on the same day, block it
      const checkoutDay = toMoment.format("YYYY-MM-DD");
      if (checkInDays.has(checkoutDay) && checkOutDays.has(checkoutDay)) {
        // Same day has both checkout and check-in, block it (or mark as pending if this request is pending)
        if (reqStatus === "pending") {
          pending.add(checkoutDay);
        } else {
          blocked.add(checkoutDay);
        }
      }

      // Enhanced early/late checkout scenarios handling
      try {
        const reqToMoment = moment.utc(reqTo);
        // const checkInTime = bookingPolicies?.checkInPolicy?.standardTime || '12:00';
        const checkOutStandardTime = bookingPolicies?.checkOutPolicy?.standardTime || '10:00';
        // build checkOutMoment in UTC for that date
        const checkOutMoment = moment.utc(reqToMoment.format('YYYY-MM-DD') + ' ' + checkOutStandardTime, 'YYYY-MM-DD HH:mm');

        const dayKey = reqToMoment.format("YYYY-MM-DD");

        // If reqTo is before the standard checkout moment, treat as early checkout; otherwise late/at-or-after checkout.
        if (reqToMoment.isBefore(checkOutMoment)) {
          // Early checkout handling
          const earlyEnabled = checkoutPolicy?.earlyCheckoutRules?.enabled;
          const minHoursEarly = checkoutPolicy?.earlyCheckoutRules?.minimumHoursEarly ?? 0;
          const refundPercentage = checkoutPolicy?.earlyCheckoutRules?.refundPercentage ?? 0;
          const processingFee = checkoutPolicy?.earlyCheckoutRules?.processingFee ?? 0;
          const earlyGapHours = checkOutMoment.diff(reqToMoment, 'hours');

          if (earlyEnabled && earlyGapHours >= minHoursEarly) {
            // Early checkout is allowed and meets minimum hours requirement
            if (refundPercentage > 0 || processingFee > 0) {
              // Mark as partial early checkout with refund/fee implications
              partial.add(dayKey);
              partialInfo.set(dayKey, {
                type: 'early',
                subType: 'refund',
                time: reqToMoment.format('HH:mm'),
                hours: Math.round(earlyGapHours * 10) / 10,
                fullCharge: false,
                refundPercentage,
                processingFee
              });
            }
            // If no refund/fee, day is fully released (no marking needed)
          } else {
            // Early checkout not allowed or doesn't meet minimum hours
            partial.add(dayKey);
            partialInfo.set(dayKey, {
              type: 'early',
              subType: earlyEnabled ? 'insufficient' : 'notAllowed',
              time: reqToMoment.format('HH:mm'),
              hours: Math.round(earlyGapHours * 10) / 10,
              fullCharge: true
            });
          }
        } else {
          // Late checkout handling
          const lateEnabled = checkoutPolicy?.lateCheckoutRules?.enabled;
          const gracePeriodMinutes = checkoutPolicy?.lateCheckoutRules?.gracePeriodMinutes ?? 0;
          const hourlyRate = checkoutPolicy?.lateCheckoutRules?.hourlyRate ?? 0;
          const maximumHours = checkoutPolicy?.lateCheckoutRules?.maximumHours ?? 24;
          const fullDayChargeAfter = checkoutPolicy?.lateCheckoutRules?.fullDayChargeAfter ?? null;

          const lateMinutes = reqToMoment.diff(checkOutMoment, 'minutes', true);
          const lateHours = reqToMoment.diff(checkOutMoment, 'hours', true);
          console.log(lateHours, fullDayChargeAfter, lateHours > fullDayChargeAfter);

          if (lateMinutes <= gracePeriodMinutes) {
            // Within grace period - no charge, no marking needed
            // Day is effectively released
          } else if (!lateEnabled) {
            // Late checkout not allowed - full day charge
            partial.add(dayKey);
            partialInfo.set(dayKey, {
              type: 'late',
              subType: 'notAllowed',
              time: reqToMoment.format('HH:mm'),
              hours: Math.round(lateHours * 10) / 10,
              fullCharge: true
            });
          } else {
            // Late checkout is allowed
            if (fullDayChargeAfter && lateHours > fullDayChargeAfter) {
              // Exceeds full day charge threshold
              partial.add(dayKey);
              partialInfo.set(dayKey, {
                type: 'late',
                subType: 'fullDay',
                time: reqToMoment.format('HH:mm'),
                hours: Math.round(lateHours * 10) / 10,
                fullCharge: true
              });
            } else if (lateHours > maximumHours) {
              // Exceeds maximum allowed hours
              partial.add(dayKey);
              partialInfo.set(dayKey, {
                type: 'late',
                subType: 'exceeded',
                time: reqToMoment.format('HH:mm'),
                hours: Math.round(lateHours * 10) / 10,
                fullCharge: true
              });
            } else {
              // Within allowed late checkout hours - hourly charge
              partial.add(dayKey);
              partialInfo.set(dayKey, {
                type: 'late',
                subType: 'hourly',
                time: reqToMoment.format('HH:mm'),
                hours: Math.round(lateHours * 10) / 10,
                fullCharge: false,
                hourlyRate
              });
            }
          }
        }
      } catch (e) {
        // if anything fails parsing times, default to original behavior (do not crash)
        console.error('Error in calculateBlockedAndPartialDays:', e);
        // no-op
      }
    });

    return { blocked, partial, partialInfo, pending };
  }

  // Custom day rendering function for DateRangePicker
  const renderDayContents = (day) => {
    const dayNumber = moment(day).date();
    if (isLoadingRenderContentDay) return <span>{dayNumber}</span>;
    const dayStr = moment(day).format("YYYY-MM-DD");
    // const dayNumber = moment(day).date();
    const isPartial = partialDaysSet.has(dayStr);
    const isPending = pendingDaysSet.has(dayStr);
    const isBlocked = blockedDaysSet.has(dayStr);
    const partialInfo = partialDaysInfo.get(dayStr);

    // Check if this day has available time with special pricing
    let availablePrice = null;
    if (!isBlocked && !isPending && availableTimes?.length > 0) {
      availableTimes.forEach((availableTime) => {
        const startDate = moment(availableTime.startDate).startOf('day');
        const endDate = moment(availableTime.endDate).startOf('day');
        const currentDay = moment(dayStr);

        if (currentDay.isSameOrAfter(startDate) && currentDay.isBefore(endDate) && availableTime.available) {
          availablePrice = availableTime.price;
        }
      });
    }

    // Check if this day is a check-in or checkout day for any non-blocked request
    let hasCheckIn = false;
    let hasCheckOut = false;

    if (!isBlocked && !isPending) {
      requestsAccepted.forEach(({ reqFrom, reqTo, reqStatus }) => {

        const fromDay = moment.utc(reqFrom).format("YYYY-MM-DD");
        const toDay = moment.utc(reqTo).format("YYYY-MM-DD");

        if (dayStr === fromDay) hasCheckIn = true;
        if (dayStr === toDay) hasCheckOut = true;
      });
    }

    // Handle pending requests with yellow background
    if (isPending) {
      return (
        <div className="w-full h-full flex flex-col items-center justify-center p-1 bg-yellow-200/60">
          <div className="text-[0.8rem] font-semibold leading-none">{dayNumber}</div>
        </div>
      );
    }

    if (isPartial && partialInfo) {
      // Enhanced indicators based on checkout scenarios
      let indicator = '';
      let colorClass = '';

      if (partialInfo.fullCharge && partialInfo.type === 'late') {
        indicator = 'FD';
        colorClass = 'text-red-800';
      } else if (partialInfo.type === 'early') {
        if (partialInfo.subType === 'refund') {
          indicator = `R${partialInfo.refundPercentage}%`;
          colorClass = 'text-blue-800';
        } else {
          indicator = `${partialInfo.hours}h-`;
          colorClass = 'text-orange-800';
        }
      } else if (partialInfo.type === 'late') {
        if (partialInfo.subType === 'hourly') {
          indicator = `${partialInfo.hours}h+`;
          colorClass = 'text-yellow-800';
        } else if (partialInfo.subType === 'fullDay') {
          indicator = 'FD';
          colorClass = 'text-red-800';
        } else {
          indicator = `${partialInfo.hours}h`;
          colorClass = 'text-red-800';
        }
      } else {
        indicator = `${partialInfo.hours}h`;
        colorClass = partialInfo.type === 'late' ? 'text-yellow-800' : 'text-green-800';
      }

      return (
        <div className={`w-full h-full flex flex-col items-center justify-center rounded-full p-1 ${partialInfo.type === 'early' ? 'bg-blue-200/40' :
          partialInfo.type === 'late' ? 'bg-yellow-200/40' : 'bg-orange-200/40'
          }`}>
          <div className="text-[0.8rem] font-semibold leading-none">{dayNumber}</div>
          <div className={`text-xs font-bold ${colorClass} mt-1`}>{indicator}</div>
        </div>
      );
    }

    // Show check-in/checkout indicators and price for non-blocked days
    if (hasCheckIn || hasCheckOut || availablePrice) {
      return (
        <div className="w-full h-full flex flex-col items-center justify-center relative">
          <div className="text-[0.8rem] font-semibold leading-none">{dayNumber}</div>
          {availablePrice && (
            <div className="text-xs text-[#9f9f9f] mt-0.5">{availablePrice}</div>
          )}
          <div className="flex gap-1 my-0.5">
            {hasCheckIn && <span className="w-2 h-2 rounded-full bg-green-500"></span>}
            {hasCheckOut && <span className="w-2 h-2 rounded-full bg-red-500"></span>}
          </div>
        </div>
      );
    }

    return <span>{dayNumber}</span>;
  };

  // Custom day modifier function
  const isDayPartial = (day) => {
    const dayStr = moment(day).format("YYYY-MM-DD");
    return partialDaysSet.has(dayStr);
  };

  // Custom day modifier function for pending days
  const isDayPending = (day) => {
    const dayStr = moment(day).format("YYYY-MM-DD");
    return pendingDaysSet.has(dayStr);
  };

  // Precompute blocked days when requestsAccepted changes
  useEffect(() => {
    setIsLoadingBlockedDays(true);
    if (!Array.isArray(requestsAccepted) || requestsAccepted.length === 0) {
      setBlockedDaysSet(new Set());
      setPartialDaysSet(new Set());
      setPartialDaysInfo(new Map());
      setPendingDaysSet(new Set());
      setIsLoadingBlockedDays(false);
      return;
    }
    // Simulate async calculation (replace with real async if needed)
    setTimeout(() => {
      const { blocked, partial, partialInfo, pending } = calculateBlockedAndPartialDays(requestsAccepted);
      setBlockedDaysSet(blocked);
      setPartialDaysSet(partial);
      setPartialDaysInfo(partialInfo);
      setPendingDaysSet(pending);
      setIsLoadingBlockedDays(false);
      setIsLoadingRenderContentDay(false);
    }, 1500);
  }, [requestsAccepted, bookingPolicies, checkoutPolicy]);

  const isDayBlocked = (day) => {
    if (isLoadingBlockedDays) return false; // Don't block any day while loading
    const dayStr = moment(day).startOf("day").format("YYYY-MM-DD");
    // treat pending days as blocked as well
    return blockedDaysSet.has(dayStr) || pendingDaysSet.has(dayStr);
  }

  const isDayBlockedOld = (day) => {
    if (!Array.isArray(requestsAccepted) || requestsAccepted.length === 0) return false;
    const dayMoment = moment(day).startOf("day");
    for (let i = 0; i < requestsAccepted.length; i++) {
      const { reqFrom, reqTo } = requestsAccepted[i];
      const fromMoment = moment(reqFrom).startOf("day");
      const toMoment = moment(reqTo).startOf("day");
      // Block only if day is strictly after reqFrom and strictly before reqTo (skip first and last day)
      if (dayMoment.isAfter(fromMoment) && dayMoment.isBefore(toMoment)) {
        return true;
      }
    }
    return false;
  }

  function handleChangeNewClient(e, id, newValue) {
    let myData = { ...newClientData }
    if (id === "clientPhone") {
      myData[id] = newValue;
    } else {
      myData[e.target.id] = e.target.value;
    }
    myData[id] = newValue;
    setNewClientData(myData)
  }

  function handleChange(e, id, newValue) {
    // deep copy
    let myData;
    requestDataRow ? myData = { ...requestDataRow } : myData = { ...requestData };
    // update data
    if (id === "client") {
      if (newValue) {
        myData[id] = newValue?.id;
        if (id === "client") {
          myData['reqClientName'] = newValue?.clientName;
        }
      }
    } else if (id === "unit") {
      if (id === "unit" && newValue?.id) {
        myData[id] = newValue?.id;
        setUnitId(newValue?.id)
        getRequestsAccepted(newValue?.id)
      } else if (newValue == null) {
        setRequestsAccepted([]);
      } else {
        setRequestsAccepted([]);
      }
    } else if (id === "date") {
      const { checkInHours, checkInMinutes, checkOutHours, checkOutMinutes } = getHoursDates(e.startDate);
      moment(e.startDate).format() === "Invalid date" ? <></> : myData["reqFrom"] = moment(e.startDate).utc(true).set({ hour: checkInHours, minute: checkInMinutes, second: 0 }).format();
      moment(e.endDate).format() === "Invalid date" ? <></> : myData["reqTo"] = moment(e.endDate).utc(true).set({ hour: checkOutHours, minute: checkOutMinutes, second: 0 }).format();
    } else if (id === "reqPayments") {
      myData[id] = newValue;
    } else if (id === "clientPhone") {
      console.log(newValue);
      myData[id] = newValue;
    } else if (id === "discountPercentage") {
      const discountPercentage = newValue > 100 ? 100 : newValue < 0 ? 0 : newValue;
      const discountAmount = Math.round(totalCost * (discountPercentage / 100), 2);
      const reqTotalCostAfterDiscount = totalCost - discountAmount;
      myData[id] = discountPercentage;
      myData["discountAmount"] = discountAmount;
      myData["reqTotalCost"] = reqTotalCostAfterDiscount.toFixed(2);
    } else {
      myData[e.target.id] = e.target.value;
    }
    // set new data
    console.log(myData);
    requestDataRow ? setRequestDataRow(myData) : setRequestData(myData);
  }

  function getHoursDates(startDate) {
    const checkInStandardTime = moment(bookingPolicies?.checkInPolicy?.standardTime || '12:00', "HH:mm");
    const checkInHours = checkInStandardTime.hour();
    const checkInMinutes = checkInStandardTime.minute();
    const checkOutStandardTime = moment(bookingPolicies?.checkOutPolicy?.standardTime || '10:00', "HH:mm");
    const checkOutHours = checkOutStandardTime.hour();
    const checkOutMinutes = checkOutStandardTime.minute();
    const partialInfo = partialDaysInfo.get(moment(startDate).format("YYYY-MM-DD"));
    const checkOutPartialDay = moment(partialInfo?.time, "HH:mm");
    const checkInHoursPartialDay = checkOutPartialDay.add(1, 'hours').hour();
    const checkInMinutesPartialDay = checkOutPartialDay.minute();
    return { checkInHours: partialInfo?.type === "late" ? checkInHoursPartialDay : checkInHours, checkInMinutes: partialInfo?.type === "late" ? checkInMinutesPartialDay : checkInMinutes, checkOutHours, checkOutMinutes };
  }

  function getOptionUnits(myData, setData) {
    const options = myData.map((ele) => {
      return (
        {
          label: ele.unitCode + " - " + ele.unitName,
          id: ele._id,
          costInterval: ele.costInterval,
          cost: ele.cost
        }
      )
    })
    setData(options);
  }

  function getOptionClient(myData, setData) {
    const options = myData.map((ele) => {
      return (
        {
          label: `${ele.clientName} - ${ele.clientPhone.slice(1)} ${ele.clientIdNumber ? " - " + ele.clientIdNumber : ""}`,
          id: ele._id,
          clientName: ele.clientName,
        }
      )
    })
    return options
  }

  function getRentingUser(myData, setData) {
    const options = myData.map((ele) => {
      return (
        {
          label: ele.email.split("@")[0] + " - " + ele.phoneNumber,
          id: ele._id,
          clientName: ele.firstName + " " + ele.lastName,
        }
      )
    })
    return options
  }

  function handleOptionClientsAndRentingUsers() {
    const clients = getOptionClient(clientResponse);
    const rentingUser = getRentingUser(rentingUserResponse);
    setClient([...clients, ...rentingUser]);
  }

  function invalidMediaAndLocation(array) {
    array?.forEach(ele => {
      if (ele.context.key === "reqFrom" || ele.context.key === "reqTo") {
        $(".date-invalid").removeClass("d-none");
      }
    });
  }

  function clearInputsDataRow() {
    if (requestDataRow) {
      setUnitCost(0);
      setNewPrice(0);
      setTotalCost(0);
      setTransaction([])
      setAvailableTime(null);
      setRequestDataRow('');
      setClearPaymentRows(true);
      setNewClientData({
        reqClientName: "",
        clientPhone: "",
        clientIdNumber: "",
      })
      getData(setUnitResponse, "unit");
      setClientOrRentingUserValue(null)
      setClientAndRentingUserValue(null)
      setClientAndRentingUserInputValue('')
    } else {
      setUnitValue(null)
      setClientAndRentingUserValue(null)
      setClientOrRentingUserValue(null)
      setClientAndRentingUserInputValue('')
      setUnitCost(0)
      setNewPrice(0)
      setTotalCost(0);
      setTransaction([]);
      setAvailableTime(null);
      setRequestsAccepted([]);
      setClearPaymentRows(true);
      setRequestData({
        reqClientName: "",
        clientPhone: "",
        clientIdNumber: "",
        reqFrom: null,
        reqTo: null,
        reqGuests: "",
        reqStatus: "",
        reqNights: 0,
        reqPayments: null,
        discountPercentage: 0,
        discountAmount: 0,
        deposit: 0,
        insurance: 0,
        reqTotalCost: 0,
        notes: "",
        idsImg: null,
      })
      getData(setUnitResponse, "unit");
    }
  }

  function validationReqData(newData) {
    const schema = joi.object().required().keys({
      // reqClientName: joi.string().pattern(/^([a-zA-Zأ-يء]+\s[a-zA-Zأ-يء]+){1,}$/).required(),
      reqClientName: joi.string().min(2).required(),
      clientPhone: joi.string().min(13).max(15),
      clientIdNumber: joi.string().allow("").length(14),
      client: joi.string().length(24).allow(null),
      rentingUser: joi.string().length(24).allow(null),
      reqFrom: joi.date().required(),
      reqTo: joi.date().required(),
      reqGuests: joi.number().required(),
      reqStatus: joi.string().max(10).required(),
      reqNights: joi.number().required(),
      reqPayments: joi.array().items({
        paymentType: joi.string().min(0).required(),
        paymentMethod: joi.string().min(0).required(),
        amountPaid: joi.number().when('paymentMethod', {
          is: "",
          then: joi.allow(0),
          otherwise: joi.required(),
        }),
        referenceNumber: joi.string().min(0).required(),
        _id: joi.string().allow(),
        createdAt: joi.date().allow(),
        paymentId: joi.string().allow(),
      }).allow(null).required(),
      discountPercentage: joi.number().min(0).max(100).required(),
      discountAmount: joi.number().required(),
      deposit: joi.number().required(),
      insurance: joi.number().required(),
      reqTotalCost: joi.number().required(),
      notes: joi.string().min(0),
      idsImg: joi.array().items(joi.string().uri()).allow(null).required(),
      unit: joi.string().required(),
    });
    return schema.validate(newData, { abortEarly: false })
  }

  async function addRequestData() {
    setIsLoading(true);
    if (!editTotalCost) {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
      setIsLoading(false);
      return 0;
    }
    if (newClient) {
      delete requestData.client;
    } else {
      delete requestData.clientPhone;
      delete requestData.clientIdNumber;
    }
    const reqStatusData = handleReqStatus(requestData);
    if (reqStatusData != null) {
      requestData.reqStatus = reqStatusData;
    } else {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
      setIsLoading(false);
      return 0;
    }
    const validationData = validationReqData(requestData);
    console.log(validationData);
    if (validationData.error) {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
      showInvalidFeedback(validationData.error.details)
      invalidMediaAndLocation(validationData.error.details)
      setIsLoading(false);
      return 0;
    } else {
      const res = await responseApi('post', requestData, "request");
      if (res.message === "success") {
        enqueueSnackbar(<>{t(addSuccessMessage)}</>, { variant: "success" });
        if (requestData.reqStatus === "settled") {
          setNewClient(false);
        }
        clearInputsDataRow()
        // Clear query parameters from URL after successful request
        if (searchParams) {
          searchParams.delete('unitId');
          searchParams.delete('reqFrom');
          searchParams.delete('reqTo');
          setSearchParams(searchParams);
        }
      } else if (res.message === "validation error") {
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
        showInvalidFeedback(res.validationError[0].details)
        invalidMediaAndLocation(res.validationError[0].details)
      } else if (res.message === "The customer is already here.") {
        setNewClient(false)
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(res.message)}</>, { variant: "error" });
      } else if (res.message === "This request cannot be accepted") {
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(res.message)}</>, { variant: "error" });
      } else {
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(res.message)}</>, { variant: "error" });
      }
    }
    showInvalidFeedback([]);
    setIsLoading(false);
  }

  async function editRequestData() {
    setIsLoading(true);
    if (!editTotalCost) {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
      setIsLoading(false);
      return 0;
    }
    const reqStatusData = handleReqStatus(requestDataRow);
    console.log(reqStatusData);

    if (reqStatusData == null) {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
      setIsLoading(false);
      return 0;
    }
    const newData = {
      reqClientName: newClient ? newClientData?.reqClientName : requestDataRow?.reqClientName,
      client: typeof (requestDataRow.client) == "string" ? requestDataRow.client : requestDataRow.client !== null ? requestDataRow.client._id : null,
      rentingUser: requestDataRow.rentingUser ? requestDataRow.rentingUser._id : null,
      reqFrom: requestDataRow.reqFrom,
      reqTo: requestDataRow.reqTo,
      reqGuests: requestDataRow.reqGuests,
      reqStatus: reqStatusData,
      reqNights: requestDataRow.reqNights,
      reqPayments: requestDataRow.reqPayments,
      discountPercentage: requestDataRow.discountPercentage,
      discountAmount: requestDataRow.discountAmount,
      deposit: requestDataRow.deposit,
      insurance: requestDataRow.insurance,
      reqTotalCost: requestDataRow.reqTotalCost,
      notes: requestDataRow.notes,
      idsImg: requestDataRow.idsImg,
      unit: typeof (requestDataRow.unit) == "string" ? requestDataRow.unit : requestDataRow.unit._id,
    }
    console.log(newClient);
    if (newClient) {
      newData.clientPhone = newClientData?.clientPhone;
      newData.clientIdNumber = newClientData?.clientIdNumber;
      delete newData.client;
    }
    const validationData = validationReqData(newData);
    console.log(validationData);
    if (validationData.error) {
      enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
      showInvalidFeedback(validationData.error.details);
      invalidMediaAndLocation(validationData.error.details);
      setIsLoading(false);
      return 0;
    } else {
      const res = await responseApi('put', newData, "request", requestDataRow._id);
      if (res.message === "success") {
        enqueueSnackbar(<>{t(editSuccessMessage)}</>, { variant: "success" });
        clearInputsDataRow()
        setNewClient(false);
        navigate("/requests");
      } else if (res.message === "validation error") {
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(validationErrorMessage)}</>, { variant: "error" });
        showInvalidFeedback(res.validationError[0].details);
        invalidMediaAndLocation(res.validationError[0].details);
      } else if (res.message === "The customer is already here.") {
        setNewClient(false)
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(res.message)}</>, { variant: "error" });
      } else {
        enqueueSnackbar(<>{t(constantsErrorMessage)}<br />{t(res.message)}</>, { variant: "error" });
      }
    }
    showInvalidFeedback([]);
    setIsLoading(false);
  }

  function clientOrRentingUserValueAutoComplete() {
    let nameValue = "";
    if (requestDataRow?.client) {
      if (requestDataRow?.client?.clientName) {
        // nameValue = requestDataRow?.client?.clientName + " - " + requestDataRow?.client?.clientPhone.slice(1)
        nameValue = `${requestDataRow?.client?.clientName} - ${requestDataRow?.client?.clientPhone.slice(1)} ${requestDataRow?.client?.clientIdNumber ? " - " + requestDataRow?.client?.clientIdNumber : ""}`
      } else {
        nameValue = clientAndRentingUserValue;
      }
    } else if (requestDataRow?.rentingUser) {
      nameValue = requestDataRow.rentingUser.email.split("@")[0] + " - " + requestDataRow.rentingUser.phoneNumber
    }
    setClientOrRentingUserValue(nameValue)
  }

  function getAmountPaidTotal(payments) {
    let total = 0;
    payments?.forEach((ele) => {
      if (ele.paymentType === "deposit") {
        total += parseFloat(ele.amountPaid);
      } else if (ele.paymentType === "refund") {
        total -= parseFloat(ele.amountPaid);
      }
    });
    setTotalAmountPaid(total);
    return total;
  }

  function handleReqStatus(data) {
    const paymentMethod = data.reqPayments?.length;
    const amountPaid = getAmountPaidTotal(data.reqPayments);
    console.log(amountPaid, parseFloat(data.reqTotalCost));
    const reqTotalCost = parseFloat(data.reqTotalCost);
    if (paymentMethod && amountPaid != 0 && amountPaid < reqTotalCost) {
      return "deposit";
    } else if ((paymentMethod && amountPaid != 0 && amountPaid >= reqTotalCost) || (reqTotalCost === 0)) {
      return "settled";
    } else if (amountPaid === 0) {
      return "pending";
    } else {
      return null;
    }
  }

  // Convert formData to BookingRequest for printing
  const getBookingRequestForPrint = () => {
    const myData = requestDataRow ? { ...requestDataRow } : { ...requestData };
    console.log(myData);
    console.log(unitValue);

    return {
      id: myData.reqCode,
      clientName: myData.reqClientName,
      phone: myData.client.clientPhone || myData.clientPhone,
      checkIn: myData.reqFrom,
      checkOut: myData.reqTo,
      unitName: myData.unit?.unitName || '',
      unitCode: myData.unit?.unitCode || '',
      guests: parseInt(myData.reqGuests) || 0,
      totalAmount: myData?.reqTotalCost || 0,
      deposits: myData.reqPayments,
      refunds: myData.reqPayments,
      status: myData.reqStatus,
      createdAt: new Date().toISOString()
    };
  };

  const handleImageUpload = async (images) => {
    try {
      setLoadingUploadImage(true);
      // if (formik.values.productImage) {
      //   handleImageDelete(formik.values.productImage);
      // }
      const file = images;
      const slug = getSlug();
      const storage = getStorage();
      const storageRef = ref(storage, `IDs/${slug}`);
      if (file.size <= 5242880) {
        const image = file;
        const nanoid = customAlphabet('1234567890abcdefghtklmnoqzx', 16);
        const imageName = nanoid();
        const imageRef = ref(storageRef, imageName);
        await uploadBytes(imageRef, image);
        // const finalImageUrl = `https://firebasestorage.googleapis.com/v0/b/ikwti-mfe.firebasestorage.app/o/invoices-checkout/${decoded.userId}/${imageName}?alt=media`;
        const downloadURL = await getDownloadURL(imageRef);
        const finalImageUrl = downloadURL.split('?')[0] + "?alt=media"
        // Store the downloadURL in your database
        console.log('Download URL:', downloadURL);
        console.log('Download URL:', finalImageUrl);
        setLoadingUploadImage(false);
        setSelectedImage(finalImageUrl);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      handleImageUpload(file);
    }
  };

  useEffect(() => {
    getData(setUnitResponse, "unit");
    getData(setClientResponse, "client");
    getData(setRentingUserResponse, "rentingUser");
    loadBookingPolicies();
    loadCheckoutPolicies();
  }, []);


  useEffect(() => {
    if (unitResponse) {
      getOptionUnits(unitResponse, setUnits);
    }
  }, [unitResponse]);

  useEffect(() => {
    if (clientResponse && rentingUserResponse) {
      handleOptionClientsAndRentingUsers();
    }
  }, [clientResponse, rentingUserResponse]);

  useEffect(() => {
    if ((requestData?.reqTo && requestData?.reqFrom && requestData?.unit) || (requestDataRow?.reqTo && requestDataRow?.reqFrom && requestDataRow?.unit)) {
      getAvailableTimeUnit();
    }
  }, [requestData.reqTo, requestData.unit, requestDataRow?.reqTo, requestDataRow?.unit]);

  useEffect(() => {
    if (requestData?._id || requestDataRow?.unit?._id) {
      getRequestsAccepted(requestDataRow?.unit?._id);
    }
  }, [requestDataRow?.unit?._id]);

  useEffect(() => {
    if ((!requestData?.unit && requestData?.reqFrom && requestData?.reqTo)) {
      getUnitsAvailableWithDate(requestData?.reqFrom, requestData?.reqTo);
    } else if (!requestDataRow?.unit && requestDataRow?.reqFrom && requestDataRow?.reqTo) {
      getUnitsAvailableWithDate(requestDataRow?.reqFrom, requestDataRow?.reqTo);
    }
  }, [requestData?.reqTo, requestData?.reqFrom, requestDataRow?.reqTo, requestDataRow?.reqFrom]);

  useEffect(() => {
    if (requestDataRow || requestDataRow === '') {
      clientOrRentingUserValueAutoComplete();
    }
  }, [requestDataRow]);

  useEffect(() => {
    getAmountPaidTotal(requestDataRow ? requestDataRow.reqPayments : requestData.reqPayments)
  }, [requestDataRow?.reqPayments, requestData?.reqPayments, requestDataRow?.discountAmount, requestData?.discountAmount]);

  useMemo(() => {
    if (queryUnitId && queryReqFromRaw && queryReqToRaw) {
      handleChange({ startDate: queryReqFromRaw, endDate: queryReqToRaw }, "date");
    }
  }, [queryUnitId, queryReqFromRaw, queryReqToRaw])

  useMemo(() => {
    if (queryUnitId && queryReqFromRaw && queryReqToRaw && units.length) {
      // Find the matching unit from the units array
      const newInputValue = units.find((unit) => unit.id === queryUnitId);

      if (newInputValue) {
        // Set the unit value with the complete unit object
        setUnitValue(newInputValue);
        // Pass the complete unit object to handleChange
        handleChange({}, "unit", newInputValue);
        // Set unit info with the complete unit object
        setInfoUnit(newInputValue);
        // Set the input value for display
        setUnitInputValue(newInputValue);
        console.log("Unit loaded from query params:", newInputValue);
      } else {
        console.warn("Unit not found for queryUnitId:", queryUnitId);
      }
    }
  }, [queryUnitId, queryReqFromRaw, queryReqToRaw, units])




  return (
    <>
      <section className='bg-babyblue-50 big-card container-fluid'>
        <div className="header-card d-flex justify-content-between align-items-center">
          <div className="header-title">
            <h2 className='fw-bolder'>{t("Add request")}</h2>
          </div>
        </div>
        <div className='container-fluid' onClick={(e) => {
          // if (popupClose(e, "add-popup")) {
          //   showInvalidFeedback([]);
          //   clearInputsDataRow();
          //   setEditTotalCost(true);
          //   setNewClient(false);
          // }
        }}>
          <ThemeProvider theme={theme}>
            {units && client ? <div className='px-3 container-fluid '>
              <ul className=' row'>
                <ToggleButton newClient={newClient} setNewClient={setNewClient} />

                {newClient ? <>
                  <li className="col-6">
                    <div className='p-2'>
                      {/* <TextField id='clientPhone' className='textfield-input' label="رقم التليفون" value={requestDataRow ? newClientData.clientPhone : requestData.clientPhone} onChange={(e) => { requestDataRow ? handleChangeNewClient(e) : handleChange(e)}} variant="standard"  type="tel" /> */}
                      <MuiTelInput defaultCountry='EG' dir='ltr' MenuProps={{ dir: "ltr" }} disableFormatting id='clientPhone' className='textfield-input' label={t("Phone Number")} value={requestDataRow ? newClientData.clientPhone : requestData.clientPhone} onChange={(newValue) => { requestDataRow ? handleChangeNewClient("", "clientPhone", newValue) : handleChange("", "clientPhone", newValue) }} variant="standard" type="tel" />
                    </div>
                    <div className="text-helper-invalid d-none">{t("Please enter the phone number. Maximum 15 digits.")}</div>
                  </li>
                  <li className="col-6">
                    <div className='px-2 pt-2'>
                      <TextField id='reqClientName' className='textfield-input' label={t("Applicant Name")} value={requestDataRow ? newClientData.reqClientName : requestData.reqClientName} onChange={(e) => { requestDataRow ? handleChangeNewClient(e) : handleChange(e) }} variant="standard" type="text" />
                    </div>
                    <div className="text-helper-invalid d-none" >{t("Please enter the applicant's name.")}</div>
                  </li>
                  <li className="col-12">
                    <div className='px-2 pt-2'>
                      <TextField id='clientIdNumber' className='textfield-input' label={t("Applicant Id Number")} value={requestDataRow ? newClientData.clientIdNumber : requestData.clientIdNumber} onChange={(e) => { requestDataRow ? handleChangeNewClient(e) : handleChange(e) }} variant="standard" type="text" />
                    </div>
                    <div className="text-helper-invalid d-none" >{t("Please enter the applicant's id number.")}</div>
                  </li>
                </> : <>
                  <li className="col-12">
                    <div className='px-2'>
                      <Autocomplete
                        dir='ltr'
                        value={clientOrRentingUserValue}
                        onChange={(event, newValue) => {
                          setClientOrRentingUserValue(newValue);
                          setClientAndRentingUserValue(newValue);
                          handleChange(event, "client", newValue || null);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        getOptionKey={(option) => option.id}
                        inputValue={clientAndRentingUserInputValue}
                        onInputChange={(event, newInputValue) => {
                          setClientAndRentingUserInputValue(newInputValue);
                        }}
                        id="client"
                        options={client}
                        sx={{ width: "100%", direction: "ltr" }}
                        renderInput={(params) => <TextField label={t("Customer Information")} variant="standard" className='textfield-input'   {...params} />}
                      />
                      <div className='text-helper-invalid d-none'>{t("Please enter customer information (phone number - name).")}</div>
                    </div>
                  </li>
                  <li className="col-12">
                    <div className='px-2 pt-2'>
                      <TextField id='reqClientName' className='textfield-input' helperText={t("You can modify the applicant's name.")} label={t("Alternate Applicant Name")} value={requestDataRow ? requestDataRow?.reqClientName : requestData.reqClientName} onChange={handleChange} variant="standard" type="text" />
                    </div>
                    <div className="text-helper-invalid d-none" >{t("Please enter the applicant's name.")}</div>
                  </li>
                </>}
                <li className={'col-12'}>
                  <div className='px-2  input-calender-addRequest w-100'>
                    <div id='date' className='w-100' >
                      <DateRangePicker
                        isRTL={i18n.language === "ar" ? true : false}
                        startDate={requestDataRow ? moment(requestDataRow.reqFrom) : moment(requestData.reqFrom).format() === "Invalid date" ? null : moment(requestData.reqFrom)}
                        endDate={requestDataRow ? moment(requestDataRow.reqTo) : moment(requestData.reqTo).format() === "Invalid date" ? null : moment(requestData.reqTo)}
                        onDatesChange={(date) => { handleChange(date, "date"); }}
                        focusedInput={focusedInput}
                        startDateId='startDate'
                        endDateId='endDate'
                        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                        startDatePlaceholderText={t("From")}
                        endDatePlaceholderText={t("To")}
                        displayFormat="YYYY/MM/DD"
                        customArrowIcon={"-"}
                        minimumNights={1}
                        numberOfMonths={window.innerWidth > 700 ? 2 : 1}
                        withPortal
                        isDayBlocked={isDayBlocked}
                        renderDayContents={renderDayContents}
                        modifiers={{
                          partial: isDayPartial,
                          pending: isDayPending
                        }}
                        hideKeyboardShortcutsPanel
                        reopenPickerOnClearDates
                        minDate={moment().startOf('month')}
                      />
                      {/* Loader overlay when DateRangePicker is open and isDayBlocked is loading */}
                      {focusedInput && isLoadingBlockedDays && (
                        <div className="fixed inset-0 z-[104] w-screen h-screen bg-transparent flex justify-center items-center fw-bold">
                          {t("loading")} <Spinner height={40} width={40} />
                        </div>
                      )}
                    </div>
                    <div className="text-helper-invalid date-invalid d-none">{t("Please specify the start and end booking dates.")}</div>
                  </div>
                </li>
                <li className="col-6">
                  <div className='px-2 pt-2'>
                    <Autocomplete
                      value={requestDataRow?.unit?.unitCode ? requestDataRow?.unit?.unitCode + " - " + requestDataRow?.unit?.unitName : unitValue}
                      onChange={(event, newValue) => {
                        setUnitValue(newValue);
                        handleChange(event, "unit", newValue);
                        setInfoUnit(newValue)
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                      inputValue={unitInputValue}
                      onInputChange={(event, newInputValue) => {
                        setUnitInputValue(newInputValue);
                      }}
                      id="unit"
                      disableClearable
                      options={units}
                      sx={{ width: "100%" }}
                      renderInput={(params) => <TextField label={t("Unit")}
                        variant="standard" className='textfield-input'   {...params} />}
                    />
                    <div className="text-helper-invalid d-none">{t("Please select the desired unit.")}</div>
                  </div>
                </li>
                <li className="col-6">
                  <div className='p-2'>
                    <TextField id='reqGuests' className='textfield-input' label={t("Number of Persons")} value={requestDataRow ? requestDataRow?.reqGuests : requestData?.reqGuests} onChange={handleChange} variant="standard" type="number" />
                  </div>
                  <div className="text-helper-invalid d-none">{t("Please enter the expected number of persons.")}</div>
                </li>
                {/* <li className="col-6">
                  <div className='p-2 d-flex '>
                    <FormControl className='textfield-input' variant="standard" >
                      <InputLabel id="demo-simple-select-standard-label">{t("Status")}</InputLabel>
                      <Select
                        MenuProps={{ disableScrollLock: true }}
                        labelId="demo-simple-select-standard-label"
                        id="reqStatus"
                        value={requestDataRow?.reqStatus ? requestDataRow?.reqStatus : requestData.reqStatus}
                        onChange={(e) => handleChange(e, "reqStatus")}
                      >
                        <MenuItem value={"pending"}>{t("pending")}</MenuItem>
                        <MenuItem value={"settled"}>{t("settled")}</MenuItem>
                        <MenuItem value={"rejected"}>{t("rejected")}</MenuItem>
                        <MenuItem value={"started"}>{t("started")}</MenuItem>
                        <MenuItem value={"finished"}>{t("finished")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="text-helper-invalid d-none">{t("Please choose the appropriate status for the request.")}</div>
                </li> */}
                <RequestPaymentsFields
                  unitValue={unitValue}
                  requestData={requestData}
                  setRequestData={setRequestData}
                  requestDataRow={requestDataRow}
                  setRequestDataRow={setRequestDataRow}
                  handleChange={handleChange}
                  clearPaymentRows={clearPaymentRows}
                  showPrintModal={showPrintModal}
                  setShowPrintModal={setShowPrintModal}
                  printType={printType}
                  setPrintType={setPrintType}
                  setSelectedDeposit={setSelectedDeposit}
                  setSelectedRefund={setSelectedRefund}
                />
                {/* <li className="col-6">
                  <div className='p-2 d-flex '>
                    <FormControl className='textfield-input' variant="standard" >
                      <InputLabel id="demo-simple-select-standard-label">{t("paymentMethod")}</InputLabel>
                      <Select
                        MenuProps={{ disableScrollLock: true }}
                        labelId="demo-simple-select-standard-label"
                        id="paymentMethod"
                        value={requestDataRow?.paymentMethod ? requestDataRow?.paymentMethod : requestData?.paymentMethod}
                        onChange={(e) => handleChange(e, "paymentMethod")}
                      >
                        <MenuItem value={"bankTransfer"}>{t("bankTransfer")}</MenuItem>
                        <MenuItem value={"egyptianPost"}>{t("egyptianPost")}</MenuItem>
                        <MenuItem value={"wallet"}>{t("wallet")}</MenuItem>
                        <MenuItem value={"cash"}>{t("cash")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="text-helper-invalid d-none">{t("pleaseSelectAPaymentMethod")}</div>
                </li>
                {(requestDataRow ? requestDataRow.paymentMethod : requestData.paymentMethod) && <li className="col-6">
                  <div className='p-2' >
                    <FormControl fullWidth variant="standard">
                      <InputLabel htmlFor="standard-adornment-amount">{t("amountPaid")}</InputLabel>
                      <Input
                        type='number'
                        inputProps={{ min: 1 }}
                        id="amountPaid"
                        onChange={handleChange}
                        value={requestDataRow ? requestDataRow.amountPaid : requestData.amountPaid}
                        endAdornment={<InputAdornment position="end"> {t("EGP")} </InputAdornment>}
                      />
                    </FormControl>
                  </div>
                  <div className="text-helper-invalid d-none">{t("pleaseEnterTheAmountPaid")}</div>
                </li>}
                <span
                  className="text-myPrimary cursor-pointer mb-2"
                  onClick={addNewRebroadcast}
                >
                  <span className='fs-5'>+</span> اضافة ميعاد
                </span> */}
                {/* <hr className='line-report w-100 mt-4 mb-2 mx-auto' /> */}
                {/* <li className="col-6">
                  <div className='px-2' >
                    <FormControl fullWidth variant="standard">
                      <InputLabel htmlFor="standard-adornment-amount">{t("Seriousness of reservation Money")}</InputLabel>
                      <Input
                        type='number'
                        inputProps={{ min: 0 }}
                        id="deposit"
                        onChange={handleChange}
                        value={requestDataRow ? requestDataRow.deposit : requestData.deposit}
                        endAdornment={<InputAdornment position="end"> {t("EGP")} </InputAdornment>}
                      // dir='rtl'
                      />
                    </FormControl>
                  </div>
                  <div className="text-helper-invalid d-none">{t("Please enter the seriousness of reservation money amount.")}</div>
                </li> */}
                {/* <li className="col-6">
                  <div className='px-2 '>
                    <FormControl fullWidth variant="standard">
                      <InputLabel htmlFor="standard-adornment-amount">{t("Insurance")}</InputLabel>
                      <Input
                        type='number'
                        inputProps={{ min: 0 }}
                        id="insurance"
                        onChange={handleChange}
                        value={requestDataRow ? requestDataRow.insurance : requestData.insurance}
                        endAdornment={<InputAdornment position="end"> {t("EGP")} </InputAdornment>}
                      // dir='rtl'
                      />
                    </FormControl>
                  </div>
                  <div className="text-helper-invalid d-none">{t("Please enter the insurance amount.")}</div>
                </li> */}
                <li className="col-12">
                  <div className='p-2'>
                    <TextField id='notes' className='textfield-input' value={requestDataRow ? requestDataRow.notes : requestData.notes} multiline rows={2} inputProps={{ maxLength: 200 }} label="ملاحظات" onChange={handleChange} variant="standard" type="text" />
                    {/* <TextField id='notes' value={requestDataRow ? requestDataRow.notes : requestData.notes} multiline rows={3}  inputProps={{ maxLength: 500 }} onChange={handleChange}   className='textfield-input' label="ملاحظات" variant="standard"  type="text" /> */}
                  </div>
                </li>
                {/* File Upload Area */}
                <li className='my-4'>
                  <UploadRequestImages data={requestDataRow ? requestDataRow : requestData} setData={requestDataRow ? setRequestDataRow : setRequestData} />
                </li>
              </ul>

              <div className='mx-4 my-4 report-request'>
                <div className='d-flex justify-content-between mb-2'>
                  <div>
                    {/* {transaction?.map((trans) =>  <p><span>{trans.nights}</span> ليلة *<span> {infoUnit.costInterval === "night" ? trans.price : (trans.price / 30.5).toFixed(2)} </span>{t("EGP")}</p> )} */}
                    <p><span>{requestDataRow ? requestDataRow.reqNights : requestData.reqNights}</span> {t("Night")} </p>
                  </div>
                  <div>
                    <p><span>{requestDataRow?.rentingUser ? parseFloat(requestDataRow.reqTotalCost).toLocaleString() : parseFloat(totalCost).toLocaleString()}</span> {t("EGP")} </p>
                  </div>
                </div>
                <div className='d-flex justify-content-between mb-2'>
                  <div>
                    <p>{t("percentageDiscount")}</p>
                  </div>
                  <div className='d-flex align-items-center'>
                    <Input id='discountPercentage' inputProps={{ min: 0, max: 100 }} style={{ width: "90px" }} type='number' value={requestDataRow ? requestDataRow.discountPercentage : requestData.discountPercentage} onChange={(e) => handleChange(e, "discountPercentage", e.target.value)} />
                    <p className=''> % </p>
                  </div>
                </div>
                {totalAmountPaid != (requestDataRow ? requestDataRow.reqTotalCost : requestData.reqTotalCost) ? <div className='d-flex justify-content-between mb-2 text-danger'>
                  <div>
                    <p>{t("totalRemaining")}</p>
                  </div>
                  <div className='d-flex align-items-center'>
                    <p><span>{parseFloat(((requestDataRow ? requestDataRow.reqTotalCost : requestData.reqTotalCost) - totalAmountPaid || 0).toFixed(2)).toLocaleString()}</span> {t("EGP")} </p>
                  </div>
                </div> : <></>}
                <hr className='line-report w-100 my-3 mx-auto' />
                <div className='d-flex justify-content-between '>
                  <div>
                    <p>{t("Total")}</p>
                    {/* <span style={{ fontSize: "10px" }}>{t("(Including earnest money)")}</span> */}
                  </div>
                  {<div className="d-flex">
                    <div className='d-flex align-items-center'>
                      <p>
                        <span >{parseFloat(requestDataRow ? Math.round(requestDataRow.reqTotalCost) : Math.round(requestData.reqTotalCost)).toLocaleString()} {t("EGP")}</span>
                        <span> {"≃"} </span>
                        <span>{parseFloat(requestDataRow ? requestDataRow.reqTotalCost : requestData.reqTotalCost).toLocaleString()} {t("EGP")}</span>

                      </p>
                    </div>
                  </div>}
                </div>
              </div>
              {/* <div className='m-4'>
                {requestDataRow?.rentingUser ? <div className='row'>
                  {requestDataRow?.idsImg.map((ele, i) => {
                    return <div className='col-md-3 col-6'>
                      <img src={ele} alt={i} className='w-100 border-radius' />
                    </div>
                  })}
                </div> : <></>}
              </div> */}
              <div className='text-start'>
                <Button variant="contained" className='btn-myPrimaryLight m-3' onClick={() => { if (!isLoading) { showInvalidFeedback([]); clearInputsDataRow(); setEditTotalCost(true); setNewClient(false); navigate("/requests"); } }}>{t("Back")}</Button>
                <Button variant="contained" disabled={availableTime === false} className={availableTime !== false ? 'btn-myPrimary ' : "btn-myPrimary opacity-75 cursor-notAllowed"} onClick={() => { !requestDataRow && availableTime !== false ? addRequestData() : editRequestData() }}>{isLoading ? <Spinner height={25} width={20} /> : t("Confirm")}</Button>
                <div>
                  {availableTime !== false ? "" : <p className=' text-notAvailable'>{t("This period is not available.")}</p>}
                </div>
              </div>
            </div> : <div className='container-fluid' style={{ backgroundColor: "transparent" }}>
              <Skeleton variant="rounded" width={"100%"} height={"100%"} style={{ borderRadius: "10px" }} />
            </div>}
          </ThemeProvider>
        </div>
      </section>
    </>
  )
}